import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/vietnamese-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/vietnamese-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/vietnamese-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/vietnamese-700.css';
import './shared/styles/tokens.css';
import './shared/styles/global.css';
import { App } from './app/App';

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
